
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/forgot",
      function () {
        return require("private-next-pages/account/forgot.js");
      }
    ]);
  